var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNereus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 136,
    viewBox: "0 0 110 136",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_78858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9998 50.2713C57.8903 52.3837 54.4671 52.3837 52.3577 50.2713L40.935 38.8327C38.8256 36.7203 35.4024 36.7203 33.2929 38.8327L3.81037 68.3565C1.7051 70.4648 1.7051 73.8797 3.81037 75.9879L17.8177 90.0148C19.9271 92.1272 23.3503 92.1272 25.4598 90.0149L36.8749 78.5838C38.9843 76.4714 42.4075 76.4714 44.517 78.5838L55.9396 90.0225C58.0491 92.1348 61.4723 92.1349 63.5817 90.0225L75.0095 78.5788C77.119 76.4664 80.5422 76.4664 82.6516 78.5788L94.0653 90.0086C96.1747 92.121 99.598 92.121 101.707 90.0086L131.19 60.4847C133.295 58.3765 133.295 54.9616 131.19 52.8533L117.183 38.8264C115.073 36.714 111.65 36.714 109.541 38.8263L98.1126 50.2701C96.0032 52.3825 92.58 52.3824 90.4706 50.27L79.0569 38.8403C76.9474 36.7279 73.5242 36.7279 71.4147 38.8403L59.9998 50.2713Z",
    fill: "url(#paint0_linear_1617_78858)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_78858",
    x1: 38.8859,
    y1: 43.3156,
    x2: 53.7886,
    y2: 105.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FFB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63A738"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_78858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNereus);
export default __webpack_public_path__ + "static/media/nereus.1e7bf34369c7d8b119e554afb2d14f54.svg";
export { ForwardRef as ReactComponent };